import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(private http: HttpClient) { }

  get(url:any, options = {}) {
    return this.http.get(url, options);
  }

  post(url:any, data:any, httpOptions = {}) {
    return this.http.post(url, data, httpOptions);
  }

  put(url:any, data: any, httpOptions = {}) {
    return this.http.put(url, data, httpOptions);
  }

  delete(url:any, httpOptions = {}) {
    return this.http.delete(url, httpOptions);
  }

  // getFile(url) {
  //   return this.http.get(url, { responseType: 'blob' });
  // }

}
